import { getExternalDataroomUrl, getExternalParticipantDataRoomUrl } from 'ClientPortal/src/common/navigation'
import { redirectDocument, type LoaderFunctionArgs } from 'react-router-dom'

type ExternalDataroomRedirectLoaderArgs = Pick<LoaderFunctionArgs, 'params' | 'request'>

export function redirectExternalParticipantPath({ request }: ExternalDataroomRedirectLoaderArgs) {
    const requestedUrl = new URL(request.url)
    return redirectDocument(getExternalDataroomUrl(`${requestedUrl.pathname}${requestedUrl.search}${requestedUrl.hash}`))
}

export function redirectLegacyExternalOrderPath({ params, request }: ExternalDataroomRedirectLoaderArgs) {
    const requestedUrl = new URL(request.url)
    const orderId = params.orderId

    if (!orderId) {
        return redirectDocument(getExternalDataroomUrl('/external-participants/not-found'))
    }

    const dataRoomUrl = new URL(getExternalParticipantDataRoomUrl(orderId))
    dataRoomUrl.search = requestedUrl.search
    dataRoomUrl.hash = requestedUrl.hash
    return redirectDocument(dataRoomUrl.toString())
}
